import firebase from "firebase/app";
import { produce } from "immer";
import _ from "lodash";
import { mergeWithArrays } from "src/util/functions";
import { RecursivePartial } from "src/util/types";
import { tUser } from "tmt_api/src/types/types.validator";
import { kUserLoggedIn, kUserLoggedOut } from "./constants";
import {
  tSetCart,
  tSetIsLoggingInLoading,
  tUpdateCart,
  tUpdateUserData,
  tUserAction,
  tUserInput,
  tUserLoggedIn,
  tUserState,
} from "./types";

export const kDefaultUser: tUser = {
  accountType: "none",
  firstName: "Jane",
  lastName: "Doe",
  email: "janedoe@gmail.com",
  phone: "+10000000000",
  customerId: 0,
  uid: "00000000-0000-0000-0000-000000000000",
  userName: "",
  userTitle: "",
  avatar: "",
  companyRefPath: "",
  role: "",
  accountScope: "",
  messageThreadsIds: [],
  dateJoined: firebase.firestore.Timestamp.now(),
};
export const kDefaultUserInput: tUserInput = {
  email: "",
  phone: "",
  userName: "",
  userTitle: "",
};

const kDefaultUserState: tUserState = {
  isLoggedIn: false,
  profile: {
    accountType: "none",
    firstName: "",
    lastName: "",
    email: "",
    phone: "+10000000000",
    uid: "",
    avatar: "",
    companyRefPath: "",
    role: "",
    accountScope: "",
    messageThreadsIds: [],
    dateJoined: firebase.firestore.Timestamp.now(),
  },
  numberOfCarts: 0,
  isLoggingInLoading: false,
};

const handleUserLoggedIn = (state: tUserState, action: tUserLoggedIn): tUserState => {
  const { profile = kDefaultUserState.profile } = action;
  return mergeWithArrays<tUserState>(state, "REPLACE", { profile, isLoggedIn: true });
};

const handleUserLoggedOut = (): tUserState => {
  return _.cloneDeep(kDefaultUserState);
};

const handleUpdateUserData = (state: tUserState, action: tUpdateUserData): tUserState => {
  return _.merge<tUserState, { profile: RecursivePartial<tUser> }>(state, { profile: action.userPart });
};

const handleSetCart = (state: tUserState, action: tSetCart): tUserState => {
  return mergeWithArrays(state, "REPLACE", { cart: action.cart, numberOfCarts: action.numberOfCarts });
};

const handleUpdateCart = (state: tUserState, action: tUpdateCart): tUserState => {
  state.cart = state.cart?.map((cart) => (cart.cartId === action.payload.id ? { ...cart, ...action.payload } : cart));
  return state;
};

const handleSetIsLoggingIn = (state: tUserState, action: tSetIsLoggingInLoading): tUserState => {
  return { ...state, isLoggingInLoading: action.isLoggingIn };
};

export const UserReducer = produce((state: tUserState = kDefaultUserState, action: tUserAction): tUserState => {
  switch (action.type) {
    case kUserLoggedIn:
      return handleUserLoggedIn(state, action);
    case kUserLoggedOut:
      return handleUserLoggedOut();
    case "UPDATE_USER_DATA":
      return handleUpdateUserData(state, action);
    case "SET_CART":
      return handleSetCart(state, action);
    case "UPDATE_CART":
      return handleUpdateCart(state, action);
    case "SET_IS_LOGGING_IN":
      return handleSetIsLoggingIn(state, action);
    default:
      return state;
  }
});
